import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ApplicationSubType, Inspection } from '../../shared/models';

@Component({
    selector: 'inspection-model-new',
    templateUrl: './new.component.html',
    standalone: false
})
export class InspectionModelNewComponent implements OnInit {
  public inspection: Inspection = new Inspection('', '', '');
  @Input() public processing;
  @Input() public showSubTypes = false;
  @Output() public toggleSaveInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  editForm: UntypedFormGroup;
  installationSubTypes = [
    { key: 'application.sub-type.PreInstallation', value: ApplicationSubType.PreInstallation },
    { key: 'application.sub-type.Installation', value: ApplicationSubType.Installation },
    { key: 'application.sub-type.Instruction', value: ApplicationSubType.Instruction }
  ];

  ngOnInit(): void {
    if (this.showSubTypes) this.inspection.applicationSubType = this.installationSubTypes[0].value;
  }

  public updateInspection() {
    this.toggleSaveInspection.emit(this.inspection);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
